import type { LeagueDailyCoverageItem } from '@/models/leagueDailyCoverage';
import type { DataTableHeader } from '@/types/vuetify';

export function createLeagueDailyCoveragePageHeaders(): DataTableHeader[] {
    const { t } = useI18n();

    return [
        {
            title: t('leagueDailyCoverage.columns.name'),
            value: 'name',
            key: 'name',
            align: 'start',
            sortable: true,
            nowrap: true,
            minWidth: 160,
        },
        {
            title: t('leagueDailyCoverage.columns.sportId'),
            value: 'sportId',
            key: 'sportId',
            align: 'start',
            sortable: true,
            nowrap: true,
            minWidth: 88,
        },
        {
            title: t('leagueDailyCoverage.columns.eventsCount'),
            value: 'eventsCount',
            key: 'eventsCount',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 72,
            width: 80,
        },
        {
            title: t('leagueDailyCoverage.columns.isTradeballNetwork'),
            value: 'isTradeballNetwork',
            key: 'isTradeballNetwork',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 120,
            sortRaw: (a: LeagueDailyCoverageItem, b: LeagueDailyCoverageItem) => a.tradeballNetworkCount - b.tradeballNetworkCount,
        },
        {
            title: t('leagueDailyCoverage.columns.pinna'),
            value: 'pinna',
            key: 'pinna',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 88,
        },
        {
            title: t('leagueDailyCoverage.columns.bf'),
            value: 'bf',
            key: 'bf',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 88,
        },
        {
            title: t('leagueDailyCoverage.columns.matchbook'),
            value: 'matchbook',
            key: 'matchbook',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 100,
        },
        {
            title: t('leagueDailyCoverage.columns.betdaq'),
            value: 'betdaq',
            key: 'betdaq',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 88,
        },
    ];
}
